import { useEffect, useState } from 'react';
import { isGoogleMapsApiConfigured, loadGoogleMapsApi } from '../utils/googleMapsLoader';

type GoogleMapsStatus = 'idle' | 'loading' | 'loaded' | 'error';

export function useGoogleMapsApi(enabled = true) {
  const [status, setStatus] = useState<GoogleMapsStatus>(enabled ? 'loading' : 'idle');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      setStatus('idle');
      setErrorMessage(null);
      return;
    }

    let cancelled = false;

    setStatus('loading');
    setErrorMessage(null);

    loadGoogleMapsApi()
      .then(() => {
        if (cancelled) return;
        setStatus('loaded');
      })
      .catch((error: Error) => {
        if (cancelled) return;
        setStatus('error');
        setErrorMessage(error.message);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return {
    status,
    errorMessage,
    isLoaded: status === 'loaded',
    isLoading: status === 'loading',
    isError: status === 'error',
    isConfigured: isGoogleMapsApiConfigured(),
  };
}
